import apiClient from "./apiClient";

/**
 * Fetch email integration status for the tenant
 * @returns {Promise<{ success: boolean, connected: boolean, provider: string, email: string }>}
 */
export const getEmailStatus = async () => {
  try {
    const res = await apiClient.get("/api/email/statuses");
    return res;
  } catch (err) {
    console.error("[EmailService] getEmailStatus error:", err);
    return { success: false, connected: false, email: "support.softrateglobal.com" };
  }
};

/**
 * Fetch email templates available for the company
 * @param {string} companyCode
 * @returns {Promise<{ success: boolean, data: Array<{ name: string, subject: string, description: string }> }>}
 */
export const getEmailTemplates = async (companyCode) => {
  try {
    const res = await apiClient.get(`/api/templates/${companyCode}`);
    return res;
  } catch (err) {
    console.error("[EmailService] getEmailTemplates error:", err);
    return { success: false, data: [] };
  }
};

/**
 * Send email from CRM via backend Resend/SMTP gateway
 * @param {FormData} formData
 * @returns {Promise<{ success: boolean, message: string, info?: any }>}
 */
export const sendEmailFromCRM = async (formData) => {
  return await apiClient.post("/api/email/messages", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
